import { BarChart } from '@wundo/ui';
import { ChartCard } from './ChartCard.tsx';
import { METRIC_INFO } from './metricsInfo.ts';
import { bucketSessions } from './sessionBuckets.ts';

export interface SessionDistributionCardProps {
  distribution: { sessions: number; users: number }[];
  average: number | null;
}

/**
 * How many users had how many sessions.
 *
 * The Vue chart drew the average as a dashed line across the plot; this one
 * prints it beside the title instead — the design system's BarChart has no
 * annotation layer, and an annotation nobody can see is worse than a number
 * everybody can read.
 */
export function SessionDistributionCard({
  distribution,
  average,
}: SessionDistributionCardProps) {
  const buckets = bucketSessions(distribution);

  return (
    <ChartCard
      title='Sessions per User (distribution)'
      info={METRIC_INFO.distribution}
      aside={
        average !== null && (
          <>
            <p className='text-xl font-semibold text-ink tabular-nums'>{average}</p>
            <p className='text-xs text-ink-muted'>avg per messaging user</p>
          </>
        )
      }
    >
      <BarChart
        ariaLabel='Users by number of sessions in the period'
        labels={buckets.map((bucket) => bucket.label)}
        series={[{ label: 'Users', data: buckets.map((bucket) => bucket.users) }]}
        height={200}
        emptyTitle='No sessions in this period'
      />
    </ChartCard>
  );
}
